import { useQuery } from '@tanstack/react-query'
import { getCardDetails, getCardDetailsKey } from '../../api-client/account'
import useVehiclePageData from '../../containers/vehicle/use-vehicle-page-data'

import { UserType } from '../../api-client/enums'
import Avatar from '../avatar'
import DealerAvatarSvg from '../svg/avatar-dealer'
import AvatarSvg from '../svg/avatar'

export default function UserInfo({ userId }) {
  const { data: userInfo = {} } = useQuery({
    queryKey: [getCardDetailsKey, userId],
    queryFn: () => getCardDetails({ userId, returnVerifiedDealer: true }),
    staleTime: 300_000,
  })

  const isDealer = userInfo.userData?.accountUserType === UserType.Dealer
  const { vehicleData } = useVehiclePageData()

  return (
    <div className='userInfo flex alignCenter'>
      <figure>
        <Avatar
          alt={`Avatar of ${userInfo.firstName}`}
          src={userInfo.profileImageUrl}
          width={[50, 35]}
          height={[50, 35]}
          fallbackComponent={isDealer ? DealerAvatarSvg : AvatarSvg}
        />
      </figure>
      <div>
        <p className='userName'>{userInfo.firstName} - Direct Offer</p>
        <p className='vehicleInfo'>
          {vehicleData?.year} {vehicleData?.make} {vehicleData?.model}
        </p>
      </div>

      <style jsx>{`
        figure {
          width: 5rem;
          height: 5rem;
          margin: 0 1.2rem 0 0;

          :global(img) {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            object-fit: cover;
          }
        }

        .userName {
          font-size: 1.8rem;
          font-weight: 700;
        }

        .vehicleInfo {
          color: #a5a8b9;
          font-size: 1.4rem;
        }

        @media (max-width: 1024px) {
          figure {
            width: 3.5rem;
            height: 3.5rem;
            margin: 0 0.8rem 0 0;
          }

          .userName,
          .vehicleInfo {
            font-size: 1.2rem;
          }
        }
      `}</style>
    </div>
  )
}
